<template>
  <span
    v-if="orderDeliveryMetrics.value"
  >
    <q-chip
      dense
      class="bg-info q-pa-sm"
      :class="$isColorDark(currentSite.infoColor) ? 'text-white' : 'text-dark'"
    >
      Early: {{ orderDeliveryMetrics.value.early }}%
    </q-chip>
    <q-chip
      dense
      class="bg-positive q-pa-sm"
      :class="$isColorDark(currentSite.positiveColor) ? 'text-white' : 'text-dark'"
    >
      On-Time: {{ orderDeliveryMetrics.value.on_time }}%
    </q-chip>
    <q-chip
      dense
      class="bg-negative q-pa-sm"
      :class="$isColorDark(currentSite.negativeColor) ? 'text-white' : 'text-dark'"
    >
      Late: {{ orderDeliveryMetrics.value.late }}%
    </q-chip>
  </span>
</template>

<script>
export default {
  name: 'KitchenDisplayMetricChips',
  configuration: ['currentSite'],
  props: {
    autoFetch: {
      type: Boolean,
      required: false,
      default: true
    },
    kitchenDisplay: {
      type: Object,
      required: true
    }
  },
  models: {
    orderDeliveryMetrics: {
      immediate: true,
      variables () {
        return {
          kitchenDisplayId: this.kitchenDisplay.id,
          skip: this.$register && !this.kitchenDisplay?.isRemote
        }
      }
    }
  },
  watch: {
    autoFetch: {
      handler () {
        if (this.autoFetch) {
          this.setUpdateOrderDeliveryMetricsInterval()
        } else {
          this.clearUpdateOrderDeliveryMetricsInterval()
        }
      },
      immediate: true
    }
  },
  beforeUnmount () {
    this.clearUpdateOrderDeliveryMetricsInterval()
  },
  methods: {
    async refresh () {
      if (this.orderDeliveryMetrics.options.skip) return

      await this.orderDeliveryMetrics.fetch(true)
    },
    setUpdateOrderDeliveryMetricsInterval () {
      if (!this.updateOrderDeliveryMetricsInterval) {
        this.updateOrderDeliveryMetricsInterval = setInterval(async () => {
          try {
            await this.refresh()
          } catch (e) {
            this.$rollbar.error('KDS failed to fetch orderDeliveryMetrics in interval', e)
          }
        }, 1000 * 60 * 5) // Every 5 minutes
      }
    },
    clearUpdateOrderDeliveryMetricsInterval () {
      if (this.updateOrderDeliveryMetricsInterval) {
        clearInterval(this.updateOrderDeliveryMetricsInterval)
        this.updateOrderDeliveryMetricsInterval = null
      }
    }
  }
}
</script>
